module.exports = __webpack_public_path__ + "static/media/illustration-justica.5e510d6a.svg";